import React from 'react';
import { TrainingDashboardKpis } from '../types';

interface Props {
  kpis: TrainingDashboardKpis | null;
}

export const TrainingMetricsCards: React.FC<Props> = ({ kpis }) => {
  if (!kpis) return null;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Training Compliance Rate</span>
        <span className="stat-value" style={{ color: '#059669' }}>{kpis.training_compliant_percentage}%</span>
        <span className="stat-sub">{kpis.assignments_completed_count} Assignments Completed</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Active Courses & Requirements</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>{kpis.active_courses_count}</span>
        <span className="stat-sub">{kpis.mandatory_requirements_count} Mandatory Requirements</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Pending / Overdue Assignments</span>
        <span className="stat-value" style={{ color: kpis.assignments_overdue_count > 0 ? '#dc2626' : '#d97706' }}>
          {kpis.assignments_pending_count}
        </span>
        <span className="stat-sub">{kpis.assignments_overdue_count} Overdue</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Training Effectiveness Rate</span>
        <span className="stat-value" style={{ color: '#7c3aed' }}>{kpis.effectiveness_rate}%</span>
        <span className="stat-sub">{kpis.qualifications_active_count} Active Qualifications / Ratings</span>
      </div>
    </div>
  );
};
